import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { MemberResponse, MemberRole, MemberSearchParams, MemberSearchStatus } from './types';

/* eslint-disable camelcase */
type QueryParams = {
  search?: string;
  limit: number;
  offset: number;
  sort_column?: string;
  sort_direction?: string;
  include_destroyed?: boolean;
  status?: MemberSearchStatus;
  role?: MemberRole;
};
/* eslint-enable camelcase */

const DEFAULT_LIMIT = 30;

/** The list envelope plus the COUNT the server runs over the same WHERE. */
export type MembersSearchResponse = PaginatedListResponse<MemberResponse> & { total?: number | null };

export async function searchMembers(params: MemberSearchParams) {
  const url = '/web/studio/users';

  const queryParams: QueryParams = {
    limit: params.limit ?? DEFAULT_LIMIT,
    offset: params.offset ?? 0,
  };

  if (params.search) {
    // Trim whitespace from search term
    const searchTerm = params.search.trim();
    if (searchTerm) {
      queryParams.search = searchTerm;
    }
  }

  if (params.sortColumn) {
    queryParams.sort_column = params.sortColumn;
  }

  if (params.sortDirection) {
    queryParams.sort_direction = params.sortDirection;
  }

  if (params.includeDestroyed !== undefined) {
    queryParams.include_destroyed = params.includeDestroyed;
  }

  if (params.status) {
    queryParams.status = params.status;
  }

  if (params.role && params.role !== 'all') {
    queryParams.role = params.role;
  }

  const response = await api.executeGetRequest<MembersSearchResponse>(url, queryParams);

  return response.data;
}
